export const helpers = {
  validate_cellphone: {
    validity: 'Por favor proporcione un número de teléfono válido',
  },
  validate_email: {
    registered: 'Este correo electrónico ya está registrado',
    validity: 'Por favor proporcione un correo electrónico válido',
  },
};
